import { render, staticRenderFns } from "./wig-page-tab-devinder.vue?vue&type=template&id=75257b11&scoped=true"
import script from "./wig-page-tab-devinder.vue?vue&type=script&lang=js"
export * from "./wig-page-tab-devinder.vue?vue&type=script&lang=js"
import style0 from "./wig-page-tab-devinder.vue?vue&type=style&index=0&id=75257b11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75257b11",
  null
  
)

export default component.exports